__turbopack_context__.v({
  "flatFloorsScheme": "FlatFloorsScheme-module-scss-module__m92uqW__flatFloorsScheme",
  "flatFloorsScheme__flat": "FlatFloorsScheme-module-scss-module__m92uqW__flatFloorsScheme__flat",
  "flatFloorsScheme__flat_alt": "FlatFloorsScheme-module-scss-module__m92uqW__flatFloorsScheme__flat_alt",
  "flatFloorsScheme__path_svg": "FlatFloorsScheme-module-scss-module__m92uqW__flatFloorsScheme__path_svg",
  "flatFloorsScheme__svg": "FlatFloorsScheme-module-scss-module__m92uqW__flatFloorsScheme__svg",
  "objectFitContain": "FlatFloorsScheme-module-scss-module__m92uqW__objectFitContain",
  "secondQueue": "FlatFloorsScheme-module-scss-module__m92uqW__secondQueue",
});
